import * as React from "react"
import Header from "./header"
import Footer from "./footer"
import { useSiteContext } from "../hooks/use-site-context"
import ExitIntentModal from "./ExitIntentModal"

const Layout = ({ children }) => {
  const [hideFooter, setHideFooter] = React.useState(true)
  const { exitIntent, currentStep } = useSiteContext()

  React.useEffect(() => {
    const path = window.location.pathname
    if (
      path.includes("welcome-back") ||
      path.includes("/wb/") ||
      path.includes("/us/") ||
      path.includes("chakra-affirmations") ||
      path.includes("article") ||
      path.includes("settings") ||
      path.includes("/fbnew")
    ) {
      console.log("ok")
    } else {
      setHideFooter(false)
    }
  }, [])

  return (
    <div className="relative flex flex-col min-h-screen antialiased bg-brand-dark fill-available">
      <Header />
      <div>
        <main className="flex flex-col flex-1">{children}</main>
        {currentStep !== 1 || hideFooter ? null : <Footer />}
      </div>
      {exitIntent && <ExitIntentModal />}
    </div>
  )
}

export default Layout
